/* jshint esversion: 6 */
import $ from 'jquery';

function dispatch(options) {
  options.attempt = options.attempt || 0;
  options.maxAttempts = options.maxAttempts || 3;
  if (options.attempt >= options.maxAttempts) {
    if (typeof(options.onError) === 'function') {
      options.onError({
        status: options.lastStatus,
        messages: ['Request attempts exceeded'],
      });
    }
    return;
  }
  options.setTimeout = options.setTimeout || setTimeout;

  const whitelist = options.whitelist || [400, 404];
  $.ajax({
    url: options.url,
    method: options.method,
    data: options.data,
    success: options.onSuccess,
    error: (xhr) => {
      options.attempt += 1;
      options.lastStatus = xhr.status;

      // don't retry on a whitelisted event (it will always fail)
      if (whitelist.indexOf(xhr.status) < 0) {
        return options.setTimeout(() => dispatch(options), Math.pow(2, options.attempt) * 1000);
      }

      if (typeof(options.onError) === 'function') {
        options.onError({
          status: options.lastStatus,
          messages: ['Hit whitelisted error'],
        });
      }
    },
  });
}

const ReliableRequest = {
  dispatch: dispatch,
};
export default ReliableRequest;
